function redirectToMaxtonSearchPage(e) {
  e.preventDefault();
  var r = [
      "maxton_brand",
      "maxton_model",
      "maxton_version",
      "maxton_generation",
      "maxton_type",
    ],
    t = document.querySelectorAll("select"),
    n = [];
  t.forEach(function (e) {
    var t = e.value;
    if (t.trim() !== "" && r.includes(e.id)) {
      n.push(t);
      saveToLocalStorage(e.id, t);
    }
  });

  // Join the selected values into a string and clean it
  var a = n
    .join(" ")
    .replace(/\brelevance\b/gi, "")
    .trim()
    .replace(",", "");

  // Remove special characters and clean up further
  a = removeSpecialCharactersFromEnd(a)
    .trim()
    .replace(/,[\s,]*$/, "");

  // Check if "/" is included in the query, don't add quotes if true
  if (a.includes("/")) {
    // If "/" is present, no quotes around the query
    checkAndReplaceQueryParam("q", a);
  } else {
    // Otherwise, wrap the query in double quotes
    // TODO: Look over (temporarily removing quotes)
    // checkAndReplaceQueryParam("q", '"' + a + '"');
    checkAndReplaceQueryParam("q", a);
  }
}
function redirectToSprintSearchPage(e) {
  e.preventDefault();

  var r = ["sprint_brand", "sprint_model", "sprint_version", "sprint_year"],
    t = document.querySelectorAll("select"),
    n = [];

  t.forEach(function (e) {
    var t = e.value;
    if (t.trim() !== "" && r.includes(e.id)) {
      n.push(t);
      saveToLocalStorage(e.id, t);
    }
  });

  // Join the selected values into a string and clean it
  var a = n
    .join(" ")
    .replace(/\brelevance\b/gi, "")
    .trim()
    .replace(",", "");

  // Remove special characters and clean up further
  a = removeSpecialCharactersFromEnd(a)
    .trim()
    .replace(/,[\s,]*$/, "");

  // Check if "/" is included in the query, don't add quotes if true
  if (a.includes("/")) {
    // If "/" is present, no quotes around the query
    checkAndReplaceQueryParam("q", a);
  } else {
    // Otherwise, wrap the query in double quotes
    // TODO: Look over (temporarily removing quotes)
    checkAndReplaceQueryParam("q", '"' + a + '"');
  }
}
function removeSpecialCharactersFromEnd(e) {
  return e.replace(/[^\w\s+\\-]]+$/, "");
}
function saveToLocalStorage(e, r) {
  localStorage.setItem(e, r);
}
const targetUrls = [
  "https://www.rpmbaltic.ee",
  "https://rpmbaltic.ee",
  "https://www.rpmbaltic.com",
  "https://rpmbaltic.com",
];
function isTargetUrl(e, r) {
  return r.includes(e);
}
function checkAndReplaceQueryParam(e, r) {
  console.log(window.location.href);
  const t = new URL(window.location.href);
  console.log(t);
  if (!isTargetUrl(t.origin, targetUrls)) throw new Error("URL");
  const n = t.pathname.split("/").filter((e) => "" !== e);
  let o = "";
  if (n.length > 0) {
    const e = n[0];
    /^[a-zA-Z]{2}$/.test(e) && (o = "/" + e);
  }
  const a = new URLSearchParams(t.search);
  a.set(e, r);
  const c = t.origin + o + "/search?" + buildQueryString(a),
    i = new URL(c);

  console.log(i.href);
  window.location.href = i.href;
}
function fixedEncodeURIComponent(e) {
  return encodeURIComponent(e).replace(/[!'()*]/g, function (e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase();
  });
}
function buildQueryString(e) {
  var r = [];
  return (
    e.forEach(function (e, t) {
      var n = fixedEncodeURIComponent(t),
        o = fixedEncodeURIComponent(e);
      r.push(n + "=" + o);
    }),
    r.join("&")
  );
}
